import React from 'react'
import styled from 'styled-components'
import SearchCustomers from '../../forcasts/Supply/Components/SearchCustomers'
import { IClientsItem } from '../../../../../modules/API/Defaults/models/customers'
import { IProblemListItem } from '../../../../../modules/API/TeudotProblems/models/problems'
import SearchProblem from './SearchProblem'
import SearchProblemStatus from './SearchProblemStatus.'
import { ISellerItem } from '../../../../../modules/API/Defaults/models/seller'
import SearchSeller from '../../market/Collect/Components/SearchSeller'

interface Props {
  selectedCustomerID: number
  setSelectedCustomerID: React.Dispatch<React.SetStateAction<number>>
  filteredCustomerList: IClientsItem[]
  closeWindow?: () => void
  selectedProblemType: number
  setSelectedProblemType: React.Dispatch<React.SetStateAction<number>>
  problemList: IProblemListItem[]
  selectedProblemStatus: number
  setSelectedProblemStatus: React.Dispatch<React.SetStateAction<number>>
  selectedSeller?: number
  setSelectedSeller?: React.Dispatch<React.SetStateAction<number>>
  filteredSellerList?: ISellerItem[]
}

const FilterContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5em;
  padding: 0.3em;
  border-radius: 30px;
  min-width: 300px;
  align-items: flex-end;
  background-color: #fff;
`

const FilterProblemMain: React.FC<Props> = ({
  selectedCustomerID,
  setSelectedCustomerID,
  filteredCustomerList,
  selectedProblemType,
  setSelectedProblemType,
  problemList,
  closeWindow,
  selectedProblemStatus,
  setSelectedProblemStatus,
  selectedSeller,
  setSelectedSeller,
  filteredSellerList
}) => {
  return (
    <FilterContainer>
      {filteredCustomerList.length > 0 && 
      (
       <>
        <SearchCustomers
          list={filteredCustomerList}
          defaultID={selectedCustomerID}
          setCustomerID={setSelectedCustomerID}
          placeholder="חפש לקוח"
          />
          {
            problemList.length > 0 && (
              <SearchProblem 
                list={problemList}
                defaultID={selectedProblemType}
                setProblemType={setSelectedProblemType}
                          
              />
            )
          }
          {
            filteredSellerList && filteredSellerList.length > 0 && (
              <SearchSeller
                list={filteredSellerList}
                defaultID={selectedSeller || 0}
                setSellerID={setSelectedSeller || (() => {})}
              />
            )
          }
          <SearchProblemStatus 
            selectedProblemStatus={selectedProblemStatus}
            setSelectedProblemStatus={setSelectedProblemStatus}
          />

        </>
      )}
    </FilterContainer>
  )
}

export default FilterProblemMain 